import cn from 'classnames';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useAppDispatch, useUser } from '@shared/hooks/index.ts';
import { Card } from '@shared/ui';
import { getErrorMessages } from '@src/library/helpers/events/errorMessages';
import { PhoneControlled } from '@src/modules/Authentication/InputsControlled';
import type { IClientForm } from '../../model';
import * as st from './styles.module.scss';

type Props = {
  disabled?: boolean;
  isLoading?: boolean;
  setPhoneVerified?: (value: boolean) => void;
  isEditable?: boolean;
  label?: string;
  isPresentation?: boolean;
};

export const Phone: React.FC<Props> = ({
  disabled,
  isLoading,
  setPhoneVerified,
  isEditable = true,
  label = 'телефон',
  isPresentation,
}): JSX.Element => {
  const {
    register,
    control,
    formState: { errors },
    setValue,
    watch,
  } = useFormContext();
  const phoneNumberValue = watch('phonenumber');

  // const {
  // 	fields: contactFields,
  // 	append: appendContact,
  // 	remove: removeContact,
  // } = useFieldArray({
  // 	name: 'phonenumber',
  // 	control,
  // });
  const { user } = useUser();
  const dispatch = useAppDispatch();
  // console.log(phoneNumberValue);
  // console.log(user?.phonenumber);
  // console.log(user?.phonenumber === phoneNumberValue || user?.phonenumber === `+${phoneNumberValue}`);
  const errorMessage = getErrorMessages(errors, ['phonenumber']);

  const localFormSave: IClientForm | null = JSON.parse(
    localStorage.getItem('clientEditorFormState')!
  );

  useEffect(() => {
    if (localFormSave !== null && localFormSave.phonenumber)
      setValue('phonenumber', localFormSave.phonenumber, { shouldValidate: true });
  }, []);

  useEffect(() => {
    if (user && setPhoneVerified) {
      if (user.phonenumber === phoneNumberValue || user.phonenumber === `+${phoneNumberValue}`) {
        setPhoneVerified(true);
        // console.log('verified');
      } else {
        // console.log('notVerified');
      }
    }
  }, [user, phoneNumberValue, setPhoneVerified]);

  return (
    <>
      <fieldset className={st.main}>
        <div className={st.main__header}>
          <h3>{label}</h3>
          <p>{errorMessage}</p>
        </div>
        {/* <div className={st.main__add}>
					<ButtonAdd
						handler={() =>
							appendContact({
								phonenumber: '',
							})
						}
						disabled={!!errors.phonenumber}
					/>
				</div> */}
        <div className={st.blocks}>
          {/* {contactFields.map((field, index) => ( */}
          <Card className={st.contact}>
            <div className={st.wrapper}>
              <div className={cn(st.phonenumber, st.phone__fullsize)}>
                {/* <div className={cn(st.phonenumber, contactFields.length === 1 && st.phone__fullsize)}></div> */}
                <PhoneControlled
                  isEditable={isEditable}
                  onValueChange={() => setPhoneVerified && setPhoneVerified(false)}
                  disabled={disabled || isLoading}
                  control={control}
                  label=""
                  error={!!errors.phonenumber}
                  name={`phonenumber`}
                  variant={isPresentation ? 'presentation' : undefined}
                />
              </div>
              {/* {contactFields.length > 1 && (
									<div className={st.delete}>
										<IconButton variant="transparent" onClick={() => removeContact(index)}>
											<Close />
										</IconButton>
									</div>
								)} */}
            </div>
          </Card>
          {/* ))} */}
        </div>
      </fieldset>
    </>
  );
};
